'use client';

import React, { useEffect, useState } from 'react';

import { BasicClose, BasicEyeOpen } from '../../../../icons/basic';
import { IconButton } from '../../../buttons/IconButton';
import { TextButton } from '../../../buttons/TextButton';
import { FullScreenDialog, FullScreenDialogClose, FullScreenDialogContent, FullScreenDialogTrigger } from '../../../dialog/FullScreenDialog';
import { createPdfUrl } from './createPdfUrl';
import { ImagePreview } from './ImagePreview';

interface PreviewModalProps {
  file: File;
  error?: boolean;
}

export function PreviewDialog(props: PreviewModalProps) {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [loadingError, setLoadingError] = useState<boolean>(props.error ?? false);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const hasError = props.error || loadingError;

  useEffect(() => {
    if (dialogOpen && props.file.type === 'application/pdf' && !pdfUrl) {
      createPdfUrl(props.file).then(setPdfUrl).catch(() => setLoadingError(true));
    }
  }, [dialogOpen, props.file, pdfUrl]);

  if (hasError) {
    return null;
  }

  return (
    <FullScreenDialog
      open={dialogOpen}
      onOpenChange={(state) => setDialogOpen(state)}
    >
      <FullScreenDialogTrigger asChild>
        <IconButton
          onClick={() => setDialogOpen(true)}
          icon={<BasicEyeOpen />}
          className="text-upload-uploaded-icon"
          label={`Bekijk het bestand: ${props.file.name}`}
          type="button"
        />
      </FullScreenDialogTrigger>
      <FullScreenDialogContent className="left-0 top-0 h-full max-h-dvh w-svw">
        <FullScreenDialogClose
          className="ml-auto h-10 w-fit"
          type="button"
        >
          <TextButton iconRight={BasicClose}>
            <div>Sluiten</div>
          </TextButton>
        </FullScreenDialogClose>
        <div className="flex max-h-full flex-1 items-center justify-center pb-16">
          {props.file.type === 'application/pdf' && pdfUrl ? (
            <embed
              src={pdfUrl}
              type="application/pdf"
              className="size-full"
            />
          ) : (
            <ImagePreview
              file={props.file}
              error={props.error}
              onError={() => setLoadingError(true)}
              className="size-full object-contain object-center"
            />
          )}
        </div>
      </FullScreenDialogContent>
    </FullScreenDialog>
  );
}
